import React from "react";
import { Button } from "./ui/button";
import { ArrowDown, Zap, Target, Users, Briefcase } from "lucide-react";

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.getElementById('nosotros');
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="inicio" className="relative py-16 md:min-h-screen md:flex md:items-center md:justify-center overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#3E97FF]/10 via-[#F6F6F6] to-[#1C3C73]/5"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-[#FF6B35]/20 rounded-full blur-xl"></div>
      <div className="absolute bottom-32 right-16 w-32 h-32 bg-[#27AE60]/20 rounded-full blur-xl"></div>
      <div className="absolute top-1/2 left-1/4 w-4 h-4 bg-[#3E97FF] rounded-full opacity-60"></div>
      <div className="absolute top-1/3 right-1/3 w-2 h-2 bg-[#FF6B35] rounded-full opacity-40"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main heading */}
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            <span className="bg-gradient-to-r from-[#3E97FF] to-[#1C3C73] bg-clip-text text-transparent">
              Infinitux
            </span>
            <br />
            <span className="text-[#252F4A]">Solutions</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-[#252F4A]/80 mb-4 font-light">
            Innovación que impulsa negocios
          </p>

          {/* Description - TEXTO MODIFICADO Y MARGEN AJUSTADO */}
          <p className="text-lg text-[#252F4A]/70 mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed">
              Impulsamos tu crecimiento con soluciones expertas en seguridad social y gestión corporativa, optimizando tus procesos con tecnología de vanguardia.
          </p>

          {/* Stats or features - MARGEN AJUSTADO */}
          <div className="flex flex-wrap justify-center gap-8 mb-8 md:mb-12">
            <div className="flex items-center space-x-2 text-[#252F4A]/70">
              <Briefcase className="w-5 h-5 text-[#27AE60]" />
              <span className="font-medium">Gestión empresarial confiable</span>
            </div>
            <div className="flex items-center space-x-2 text-[#252F4A]/70">
              <Zap className="w-5 h-5 text-[#3E97FF]" />
              <span className="font-medium">Tecnología Avanzada</span>
            </div>            
            <div className="flex items-center space-x-2 text-[#252F4A]/70">
              <Users className="w-5 h-5 text-[#FF6B35]" />
              <span className="font-medium">Soporte Especializado</span>
            </div>
          </div>

          {/* CTA buttons - YA USA sm:flex-row para apilar en móvil */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={scrollToAbout}
              className="bg-[#3E97FF] hover:bg-[#1C3C73] text-white px-8 py-4 text-lg rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              Conócenos
            </Button>
            <Button 
              variant="outline"
              onClick={() => document.getElementById('servicios').scrollIntoView({ behavior: "smooth" })}
              className="border-[#3E97FF] text-[#3E97FF] hover:bg-[#3E97FF] hover:text-white px-8 py-4 text-lg rounded-lg transition-all duration-300"
            >
              Ver Servicios
            </Button>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <ArrowDown className="w-6 h-6 text-[#3E97FF]/60" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;